







































































































































































import { Component, InjectReactive, Prop, Vue, Watch } from 'vue-property-decorator'
import { RealworksStatusRule } from '@/api/model/realworks-status-rule'
import { cloneDeep, isEqual } from 'lodash'
import { InputSelectOption } from '@/helpers/options'
import { RealworksAPI } from '@/api/client/realworks'

@Component
export default class CreatePhaseStatusFormStep1 extends Vue {
    @Prop({ required: true }) readonly value!: RealworksStatusRule
    editingValue: RealworksStatusRule = null
    triggerType: string = null
    @InjectReactive() loadingKenmerken!: boolean
    @InjectReactive() kenmerken!: InputSelectOption[]
    agendaTypes: InputSelectOption[] = []
    loadingAgendaTypes: boolean = true
    agendaStatussen: InputSelectOption[] = []
    loadingAgendaStatussen: boolean = true
    taakTypes: InputSelectOption[] = []
    loadingTaakTypes: boolean = true
    taakStatussen: InputSelectOption[] = []
    loadingTaakStatussen: boolean = true

    @Watch('value', { immediate: true })
    onValueChanged() {
        this.editingValue = cloneDeep(this.value)
        if (!this.triggerType) {
            this.triggerType = this.editingValue.triggerType
        }
    }

    @Watch('editingValue.kenmerken')
    @Watch('editingValue.objectStatus')
    @Watch('editingValue.objectRelatieTypes')
    @Watch('editingValue.agendaTypes')
    @Watch('editingValue.agendaStatus')
    @Watch('editingValue.taakTypes')
    @Watch('editingValue.taakStatus')
    @Watch('editingValue.assignToMedewerker')
    onEditingValueChanged() {
        if (isEqual(this.editingValue, this.value)) {
            return
        }

        this.$emit('update:value', this.editingValue)
    }

    @Watch('triggerType')
    onTriggerTypeChanged(): void {
        if (this.triggerType !== 'kenmerken') {
            this.editingValue.kenmerken = []
        }

        if (this.triggerType !== 'agendaTypes') {
            this.editingValue.agendaTypes = []
            this.editingValue.agendaStatus = null
        }

        if (this.triggerType !== 'taakTypes') {
            this.editingValue.taakTypes = []
            this.editingValue.taakStatus = null
        }

        if (this.triggerType !== 'objectStatuses') {
            this.editingValue.objectStatus = null
            this.editingValue.objectRelatieType = null
        }

        this.reload()
    }

    mounted() {
        this.reload()
    }

    reload() {
        this.loadAgendaTypes()
        this.loadAgendaStatussen()
        this.loadTaakTypes()
        this.loadTaakStatussen()
    }

    async loadAgendaTypes() {
        this.loadingAgendaTypes = true

        const agendaTypes = await RealworksAPI.getAgendatypes()
        this.agendaTypes = agendaTypes
            .map(agendatype => ({
                label: agendatype,
                value: agendatype,
            }))
            .sort((a, b) => a.label.localeCompare(b.label))

        this.loadingAgendaTypes = false
    }

    async loadAgendaStatussen() {
        this.loadingAgendaStatussen = true

        const agendaStatussen = await RealworksAPI.getAgendaStatussen()
        this.agendaStatussen = agendaStatussen
            .filter(status => status.actief)
            .sort((a, b) => a.volgorde > b.volgorde ? 1 : -1)
            .map(status => ({
                label: status.status,
                value: status.status,
            }))

        this.agendaStatussen.unshift({
            label: this.$t('forms.edit_realworks_status_rule_form.emptyAgendaStatus').toString(),
            value: null,
        })

        this.loadingAgendaStatussen = false
    }

    async loadTaakTypes() {
        this.loadingTaakTypes = true

        const taakTypes = await RealworksAPI.getTaaktypes()
        this.taakTypes = taakTypes
            .map(taak => ({
                label: taak,
                value: taak,
            }))
            .sort((a, b) => a.label.localeCompare(b.label))

        this.loadingTaakTypes = false
    }

    async loadTaakStatussen() {
        this.loadingTaakStatussen = true

        const taakStatussen = await RealworksAPI.getTaakStatussen()
        this.taakStatussen = taakStatussen
            .filter(status => status.actief)
            .sort((a, b) => a.volgorde > b.volgorde ? 1 : -1)
            .map(status => ({
                label: status.status,
                value: status.status,
            }))

        this.taakStatussen.unshift({
            label: this.$t('forms.edit_realworks_status_rule_form.emptyTaakStatus').toString(),
            value: null,
        })

        this.loadingTaakStatussen = false
    }

    get triggerTypeOptions() {
        return [
            { label: this.$t('forms.edit_realworks_status_rule_form.triggerTypes.kenmerken'), value: 'kenmerken' },
            { label: this.$t('forms.edit_realworks_status_rule_form.triggerTypes.agendaTypes'), value: 'agendaTypes' },
            { label: this.$t('forms.edit_realworks_status_rule_form.triggerTypes.taakTypes'), value: 'taakTypes' },
            { label: this.$t('forms.edit_realworks_status_rule_form.triggerTypes.objectStatuses'), value: 'objectStatuses' },
        ]
    }

    get objectStatuses() {
        return [
            { label: this.$t('forms.edit_realworks_status_rule_form.objectStatuses.prospect'), value: 'PROSPECT' },
            { label: this.$t('forms.edit_realworks_status_rule_form.objectStatuses.in-aanmelding'), value: 'IN_AANMELDING' },
            { label: this.$t('forms.edit_realworks_status_rule_form.objectStatuses.beschikbaar'), value: 'BESCHIKBAAR' },
            { label: this.$t('forms.edit_realworks_status_rule_form.objectStatuses.onder-bod'), value: 'ONDER_BOD' },
            { label: this.$t('forms.edit_realworks_status_rule_form.objectStatuses.onder-optie'), value: 'ONDER_OPTIE' },
            { label: this.$t('forms.edit_realworks_status_rule_form.objectStatuses.verkocht-onder-voorbehoud'), value: 'VERKOCHT_ONDER_VOORBEHOUD' },
            { label: this.$t('forms.edit_realworks_status_rule_form.objectStatuses.verhuurd-onder-voorbehoud'), value: 'VERHUURD_ONDER_VOORBEHOUD' },
            { label: this.$t('forms.edit_realworks_status_rule_form.objectStatuses.verkocht'), value: 'VERKOCHT' },
            { label: this.$t('forms.edit_realworks_status_rule_form.objectStatuses.verhuurd'), value: 'VERHUURD' },
            { label: this.$t('forms.edit_realworks_status_rule_form.objectStatuses.geveild'), value: 'GEVEILD' },
            { label: this.$t('forms.edit_realworks_status_rule_form.objectStatuses.ingetrokken'), value: 'INGETROKKEN' },
            { label: this.$t('forms.edit_realworks_status_rule_form.objectStatuses.ingetrokken-tijdelijk'), value: 'INGETROKKEN_TIJDELIJK' },
            { label: this.$t('forms.edit_realworks_status_rule_form.objectStatuses.geannuleerd'), value: 'GEANNULEERD' },
            { label: this.$t('forms.edit_realworks_status_rule_form.objectStatuses.verkocht-bij-inschrijving'), value: 'VERKOCHT_BIJ_INSCHRIJVING' },
        ]
    }

    get objectRelatieTypes() {
        return [
            { label: this.$t('forms.edit_realworks_status_rule_form.objectRelatieTypes.aankoop'), value: 'aankoop' },
            { label: this.$t('forms.edit_realworks_status_rule_form.objectRelatieTypes.verkoop'), value: 'verkoop' },
            { label: this.$t('forms.edit_realworks_status_rule_form.objectRelatieTypes.beide'), value: 'beide' },
        ]
    }

    get supportsAssignToMedewerker(): boolean {
        return this.triggerType === 'agendaTypes'
    }

    get yesNoOptions() {
        return [
            { label: this.$t('yes'), value: true },
            { label: this.$t('no'), value: false },
        ]
    }
}
